import { memo } from 'react';

import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Grid } from '@/components/shared/layout/grid';
import type { IParts } from '@/types/shared/parts';

interface PartsNoteProps {
  note?: IParts['note'];
  dataTest?: string;
}

export const PartsNote = memo(
  ({ note = {}, dataTest = 'popup_partsDetail' }: PartsNoteProps) => {
    return (
      <Box
        paddingX="4"
        paddingY="3"
        test={{
          dataTest: dataTest + '_remark',
        }}
      >
        <Grid columnGap="1" css={{ gridTemplateColumns: 'max-content auto' }}>
          {!!note?.title && (
            <Text as="p" size="text-caption">
              {note?.title}
            </Text>
          )}
          {!!note?.description && (
            <Text
              as="p"
              size="text-caption"
              wrap
              dangerouslySetInnerHTML={{
                __html: note?.description,
              }}
            />
          )}
        </Grid>
      </Box>
    );
  }
);

PartsNote.displayName = 'SectionPartsItemPartsNote';
